export const config = {
  key: `${process.env.REACT_APP_API_Froala_Key}`, // Key for Froala
  placeholderText: "Start typing...",
  charCounterCount: true,
  toolbarButtons: [
    "bold",
    "italic",
    "underline",
    "strikeThrough",
    "subscript",
    "superscript",
    "|",
    "fontFamily",
    "fontSize",
    "color",
    "inlineStyle",
    "paragraphStyle",
    "|",
    "paragraphFormat",
    "align",
    "formatOL",
    "formatUL",
    "outdent",
    "indent",
    // "quote",
    "|",
    "insertLink",
    "insertImage",
    // "insertVideo",
    // "insertFile",
    "insertTable",
    "|",
    // "emoticons",
    "specialCharacters",
    "embedly",
    "insertHR",
    "selectAll",
    "clearFormatting",
    "|",
    // "print",
    "spellChecker",
    "help",
    "html",
    "|",
    "undo",
    "redo",
  ],
  fontFamily: {
    "Figtree, sans-serif": "Figtree", // 👈 custom font
    "Arial,Helvetica,sans-serif": "Arial",
    "Georgia,serif": "Georgia",
    "Impact,Charcoal,sans-serif": "Impact",
    "Tahoma,Geneva,sans-serif": "Tahoma",
    "Times New Roman,Times,serif": "Times New Roman",
    "Verdana,Geneva,sans-serif": "Verdana",
  },

  fontSize: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 28, 32, 36, 48, 60, 72],
  // 👇 Add this to hide URL and File in image popup
  imageInsertButtons: ["imageUpload"], // only allow upload

  // Default classes for new tables
  tableClass: "table table-bordered table-responsive", // 👈 auto-apply

  // Table style options in the dropdown
  // tableStyles: {
  //   "": "None", // 👈 no extra class
  //   // "table-bordered": "Bordered", // 👈 bootstrap bordered
  // },
  tableStyles: {
    "": "None",
    "table-bordered": "Bordered",
    "table-striped": "Striped",
    "table-hover": "Hover",
    "table-responsive": "Responsive",
  },

  // tableClass: "table table-bordered table-responsive", // 👈 auto-apply
  // tableStyles: {
  //   "table-bordered": "Bordered",
  //   "table-striped": "Striped",
  //   "table-responsive": "Responsive",
  // },
  tableEditButtons: [
    "tableHeader",
    "tableRemove",
    "tableRows",
    "tableColumns",
    "tableStyle",
    "tableCellBackground",
    "tableCellStyles",
    "tableMerge",
    "tableSplit",
  ],
  // pluginsEnabled: [
  //   "table",
  //   "align",
  //   "colors",
  //   "link",
  //   "image",
  //   "file",
  //   "video",
  // ],

  toolbarButtonsXS: null,
  toolbarButtonsSM: null,
  toolbarButtonsMD: null,
  imageUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,
  // `

  // Video upload endpoint (if needed)
  videoUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  // File upload endpoint
  fileUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  // 👇 Ensure uploads send cookies/session tokens
  requestWithCORS: true,
  requestWithCredentials: true,

  // Extra settings
  imageUploadParam: "file", // 👈 match multer field name
  fileUploadParam: "file",
  videoUploadParam: "file",
  events: {
    "image.uploaded": function (response) {
      const res = JSON.parse(response);
      debugger;
      if (res.link) {
        this.image.insert(
          `${process.env.REACT_APP_API_IMAGE_URL}${res.link}`, // ✅ use IMAGE_URL, not API_URL
          true,
          null,
          this.image.get(),
          response
        );
        return false; // prevent Froala default insert
      }
    },
    "video.uploaded": function (response) {
      const res = JSON.parse(response);
      if (res.link) {
        const videoUrl = `${process.env.REACT_APP_API_IMAGE_URL}${res.link}`;

        // Insert actual video tag
        this.html.insert(
          `<video controls style="max-width:100%">
         <source src="${videoUrl}" type="video/mp4">
         Your browser does not support the video tag.
       </video>`
        );

        return false; // prevent Froala from inserting just the URL
      }
    },

    "file.uploaded": function (response) {
      const res = JSON.parse(response);
      if (res.link) {
        this.file.insert(
          `${process.env.REACT_APP_API_IMAGE_URL}${res.link}`,
          res.name || "Download file",
          response
        );
        return false;
      }
    },
    // After inserting a blockquote, add default color
    events: {
      "commands.after": function (cmd) {
        if (cmd === "quote") {
          const blockquote = this.selection.element();
          if (blockquote && blockquote.tagName === "BLOCKQUOTE") {
            blockquote.style.color = "#00bcd4";
            blockquote.style.borderLeft = "4px solid #00bcd4";
            blockquote.style.paddingLeft = "1rem";
          }
        }
      },
    },
  },

  // Example: image upload endpoint on your server

  // Additional options you might use:
  // imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  // fileUploadURL: '/api/uploads/froala-file',
  //
};
